export default __webpack_public_path__ + "static/media/bg-ipo.67117f82.svg";